import { sampleLushootseed } from "../../ruleSets/lushootseedSampler";
import { EditSpeakOptions } from "../EditSpeakOptions";
import { ConvertLS } from "./ConvertLS";
import { TableOfSamples } from "./TableOfSamples";

/** a page where you can listen to a synth version of Lushootseed */
export function Lushootseed() {
  return (<>
    <h1>Lushootseed</h1>

    <div style={{ display: 'grid', gridTemplateColumns: 'auto 100px 220px', justifyContent: 'center' }}>
      <div>
        <ConvertLS />
        <br /><br />

        <p>
          Sample words from <a href="https://tulaliplushootseed.com/alphabet/">Tulalip Lushootseed site</a>.
        </p>
        <TableOfSamples letters={sampleLushootseed} />
      </div>

      <div></div>

      <div style={{ textAlign: 'left' }}>
        Synthesizer Settings<br /><br />
        <EditSpeakOptions vertical={true} />
      </div>
    </div>
  </>);
}
